import groq from 'groq';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchScience = () => groq`
  *[
    _type == "timeline_scienceV2" &&
    !(_id in path("drafts.**"))
  ] | score(
      boost(_id match $searchTerm, 3),
      boost(pt::text(hero) match $searchTerm, 2),
      effectsOnBody->title match $searchTerm,
      effectsOnBody->description match $searchTerm,
      effectsOnBody->callouts[].label match $searchTerm,
      effectsOnBody->callouts[].description match $searchTerm,
      cellularDecline.scrollVideo.title match $searchTerm,
      slimBanner.title match $searchTerm,
      slimBanner.subtitle match $searchTerm,
    ) {
      _type,
      _score
    }[ _score > 0 ]
`;
